import { Grid, Stack, Typography } from '@mui/material';

import { Icon } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { ResponsibilityLetterOperatorsEnum } from '@services/CompanyService';

import useDeviceBreakpoints from 'hooks/useDeviceBreakpoints';

import { StyledCard, StyledTypography } from './styles';
import type { AcceptDetailProps } from './types';

export function AcceptDetail({ acceptDetail }: Readonly<AcceptDetailProps>) {
  const { isMobileOrTablet } = useDeviceBreakpoints();
  const { observation, createdAt, operator } = acceptDetail ?? {};

  const isChangedByPortal =
    operator === ResponsibilityLetterOperatorsEnum.PORTAL;

  return (
    <StyledCard>
      <Stack
        gap={1}
        flexDirection={isMobileOrTablet ? 'column' : 'row'}
        justifyContent="flex-start"
        mb={2}
      >
        <Stack flexDirection="row" alignItems="center" gap={0.5}>
          <Icon
            name="medical-b2b-contract-check"
            size={32}
            color={NEW_COLORS.PRIMARY[500]}
          />
          <Typography fontWeight={900} color={NEW_COLORS.PRIMARY[500]}>
            Detalhes do aceite
          </Typography>
        </Stack>
      </Stack>
      {isChangedByPortal ? (
        <Grid container spacing={2}>
          <Grid item xs={12} md={10}>
            <Typography variant="caption" fontWeight="bold">
              Observação
            </Typography>
            <StyledTypography variant="body2" title={observation}>
              {observation}
            </StyledTypography>
          </Grid>

          <Grid item xs={12} md={2}>
            <Typography variant="caption" fontWeight="bold">
              Data do aceite
            </Typography>
            <Typography variant="body2">{createdAt}</Typography>
          </Grid>
        </Grid>
      ) : (
        <Stack>
          <Typography fontSize={16} variant="text">
            Essa empresa já possui{' '}
            <Typography fontWeight={700} variant="text">
              carta de responsabilidade
            </Typography>{' '}
            assinada através de fluxo externo. Para mais informações, entre em
            contato com o executivo da conta ou através dos canais de
            atendimento.
          </Typography>
        </Stack>
      )}
    </StyledCard>
  );
}
